import { PILLAR_FILMS } from "@/lib/api";
import Reveal from "@/components/Reveal";
import PillarShowcase from "@/components/PillarShowcase";

const PILLARS = [
  {
    id: "township",
    tag: "01 · TOWNSHIPS",
    tagCls: "text-[#00F0FF]",
    hover: "hover:border-[#00F0FF]/40",
    title: "Smart Township Development",
    desc: "Centralized energy microgrids, AI surveillance, automated perimeter security, and municipal telemetry.",
    film: PILLAR_FILMS.township,
    testid: "pillar-township",
  },
  {
    id: "automation",
    tag: "02 · RESIDENCES",
    tagCls: "text-[#FF1E8C]",
    hover: "hover:border-[#FF1E8C]/40",
    title: "Smart Homes Automation",
    desc: "Custom acoustic scenes, biometric access gates, human-centric lighting, and voice AI orchestration.",
    film: PILLAR_FILMS.rooms,
    testid: "pillar-homes",
  },
  {
    id: "commercial",
    tag: "03 · COMMERCIAL",
    tagCls: "text-[#FF2E2E]",
    hover: "hover:border-[#FF2E2E]/40",
    title: "Smart Hotel & Office",
    desc: "Keyless guest check-in, dynamic conference automation, load shedding, and occupancy analytics.",
    film: PILLAR_FILMS.hotelops,
    testid: "pillar-commercial",
  },
];

export default function Pillars() {
  return (
    <section id="township" className="py-24 px-6 max-w-6xl mx-auto scroll-mt-20" data-testid="pillars-section">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
        <div>
          <span className="font-mono-lbl text-xs text-[#00F0FF] uppercase tracking-widest block mb-2">Integrated Solutions</span>
          <h2 className="font-disp text-4xl sm:text-5xl uppercase tracking-tight">Ecosystem Architecture</h2>
        </div>
        <p className="text-white/70 max-w-md text-sm">
          Engineered for massive township grids down to intimate master suites with zero latency.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {PILLARS.map((p, i) => (
          <Reveal key={p.testid} delay={i * 120}>
          <div
            id={p.id === "automation" ? "automation" : undefined}
            className={`group border border-white/10 rounded-2xl p-6 bg-[#061536]/50 ${p.hover} transition-colors h-full scroll-mt-24`}
            data-testid={p.testid}
          >
            <div className="aspect-[4/3] rounded-xl mb-6 overflow-hidden relative bg-[#02050F]">
              <PillarShowcase video={p.film} captions={p.film.captions} segment={p.film.segment} label={p.film.label} testid={p.testid} />
              <div className="absolute inset-0 bg-gradient-to-t from-[#061536]/90 via-transparent to-transparent pointer-events-none" />
              <span className={`absolute top-3 left-3 bg-[#061536]/90 font-mono-lbl text-[10px] ${p.tagCls} px-2.5 py-1 rounded`}>
                {p.tag}
              </span>
            </div>
            <h3 className="font-disp text-2xl uppercase mb-2">{p.title}</h3>
            <p className="text-white/70 text-sm leading-relaxed">{p.desc}</p>
          </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
